import React, { useState, useEffect } from 'react';
import { Checkbox } from 'module-tsl-ui-elements';
import { getFromContext } from '../../../AlertFiltersContext';

export const FilterCategoryItem = ({ item, children, isApplicationType }) => {
  const { state, dispatch } = getFromContext();

  const isFacetSelected = (facet) => {
    const selectedIDs = state.facets.map((selection) => selection.queryStringId);
    return selectedIDs.indexOf(facet.queryStringId) !== -1;
  };

  const [checked, setChecked] = useState(isFacetSelected(item));

  useEffect(() => {
    setChecked(isFacetSelected(item));
  }, [state.facets]);

  const onChange = ({ target }) => {
    setChecked(target.checked);
    dispatch({
      type: target.checked ? 'add' : 'remove',
      facet: item,
    });
  };

  const isParent = !item.parent && checked;

  return isApplicationType ? (
    <>
      <Checkbox
        className="filters__category__application-type"
        caption={item.name}
        showLabel
        onChange={onChange}
        checked={checked}
      />
      <span>Lets you apply faster using My CV, which saves your details for further applications.</span>
    </>
  ) : (
    <li key={item.queryStringId}>
      <Checkbox caption={item.name} showLabel onChange={onChange} checked={checked} />
      {isParent && children}
    </li>
  );
};
